// Generated by Melange

import * as $$BigInt from "./BigInt.mjs";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.mjs";
import * as Curry from "melange.js/curry.mjs";
import * as Js__Js_exn from "melange.js/js_exn.mjs";
import * as LindenAPI from "./LindenAPI.mjs";
import * as Melange__RegexRender from "./RegexRender.mjs";
import * as Melange__TreeConvert from "./TreeConvert.mjs";
import * as Stdlib__Option from "melange/option.mjs";
import * as Warblre_js__Extracted from "warblre-engines.js/Extracted.mjs";
import * as Warblre_js__JsEngineParameters from "warblre-engines.js/JsEngineParameters.mjs";
import * as Warblre_js__Parser from "warblre-engines.js/Parser.mjs";

function warblre_Regex_to_viz(prim) {
  return prim;
}

function parseRegex(str) {
  const Parser = Warblre_js__Parser.Parser(Warblre_js__JsEngineParameters.JsParameters, Warblre_js__JsEngineParameters.JsStringLike);
  const str$1 = str === "" ? "(?:)" : str;
  return Curry._1(Parser.parseRegex, "/" + (str$1 + "/"));
}

function error_message(e) {
  return Stdlib__Option.value(Stdlib__Option.bind(Js__Js_exn.asJsExn(e), (function (prim) {
    return prim.message;
  })), "invalid regex");
}

const JsEngine = Warblre_js__Extracted.API.Engine(Warblre_js__JsEngineParameters.JsParameters);

const linden_params = LindenAPI.lindenParameters_of_warblre(JsEngine.parameters);

function numberSubregexes(root) {
  const counter = {
    contents: 0
  };
  const idMap = {
    contents: /* [] */ 0
  };
  const go = function (_r) {
    while (true) {
      const r = _r;
      idMap.contents = {
        hd: [
          r,
          counter.contents
        ],
        tl: idMap.contents
      };
      counter.contents = counter.contents + 1 | 0;
      if (/* tag */ typeof r === "number" || typeof r === "string") {
        return;
      }
      switch (r.TAG) {
        case /* Disjunction0 */ 1 :
        case /* Sequence */ 2 :
          go(r._0);
          _r = r._1;
          continue;
        case /* Quantified0 */ 3 :
          _r = r._3;
          continue;
        case /* Lookaround */ 4 :
        case /* Group0 */ 5 :
          _r = r._1;
          continue;
        default:
          return;
      }
    };
  };
  go(root);
  return idMap.contents;
}

function clear(target) {
  target.innerHTML = "";
}

function run(pattern, flags, input, startIdx, fuel, regexView, onHover) {
  regexView.innerHTML = "";
  try {
    const wregex = parseRegex(pattern);
    const parsed = LindenAPI.Extraction.linden_regex_of_warblre_regex(linden_params, wregex);
    const regex = LindenAPI.Extraction.maybe_add_lazy_prefix(linden_params, flags, parsed);
    const chars = Curry._1(Warblre_js__JsEngineParameters.JsParameters.$$String.list_from_string, Warblre_js__JsEngineParameters.JsStringLike.of_string(input));
    const startIdx$1 = $$BigInt.of_int(startIdx);
    const fuel$1 = $$BigInt.of_int(fuel);
    const idMap = numberSubregexes(regex);
    Melange__RegexRender.render_regex(regex, regexView, idMap, onHover);
    const tree = LindenAPI.Extraction.tree_of_linden_regex(linden_params, regex, flags, chars, startIdx$1, fuel$1);
    if (/* tag */ typeof tree === "number" || typeof tree === "string") {
      if (tree === /* TEOutOfFuel */ 0) {
        return {
          NAME: "Error",
          VAL: "out of fuel"
        };
      } else {
        return {
          NAME: "Error",
          VAL: "unsupported regex flag"
        };
      }
    } else {
      return {
        NAME: "Ok",
        VAL: Melange__TreeConvert.to_tree(idMap, input, tree._0)
      };
    }
  }
  catch (raw_e){
    const e = Caml_js_exceptions.internalToOCamlException(raw_e);
    return {
      NAME: "Error",
      VAL: error_message(e)
    };
  }
}

export {
  warblre_Regex_to_viz,
  parseRegex,
  error_message,
  linden_params,
  numberSubregexes,
  clear,
  run,
}
/* JsEngine Not a pure module */
